import { render, staticRenderFns } from "./RestaurantFilter.vue?vue&type=template&id=dec98958&scoped=true"
import script from "./RestaurantFilter.vue?vue&type=script&lang=js"
export * from "./RestaurantFilter.vue?vue&type=script&lang=js"
import style0 from "./RestaurantFilter.vue?vue&type=style&index=0&id=dec98958&prod&lang=scss&scoped=true"
import style1 from "./RestaurantFilter.vue?vue&type=style&index=1&id=dec98958&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec98958",
  null
  
)

export default component.exports